import React, { useEffect, useState } from 'react'
// import FilterBar from '../FilterBar/FilterBar'
import MyTickets from '../MyTickets/MyTickets'
import "./MyTicketsView.css"
// import "./FilterBar.css"
import CircleIcon from '@mui/icons-material/Circle';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import Close from '@mui/icons-material/Close';
import AlarmIcon from '@mui/icons-material/Alarm';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import MessageOutlined from '@mui/icons-material/MessageOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import SideBar from '../SideBar/SideBar';
import axiosApiInstance from '../axios';
import AllTicketsHeader from '../AllTickets/AllTicketsHeader';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import TextField from '@mui/material/TextField';
import { ReactComponent as BtLogo } from "../images/btLogo.svg";
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

const MyTicketsView = () => {
    const defaultStatus = 21;
    const userPhoneNumber = localStorage.getItem('userPhoneNumber');
    const [filterKeywords, setFilterKeywords] = useState([]);
    const [filterwords, setFilterwords] = useState([]);
    const [isActiveState, setIsActiveState] = useState('New');
    const [isActivePriorty, setIsActivePriorty] = useState();
    const [stateVisible, setStateVisible] = useState(false);
    const [priorityVisible, setPriorityVisible] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');
    const [called, setCalled] = useState(defaultStatus);
    const [prio, setprio] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [open, setOpen] = useState(false);
    const [isVerifyPopupOpen, setIsVerifyPopupOpen] = useState(false);
    const [code, setCode] = useState('');
    const [phoneNumberErrorMssg, setPhoneNumberErrorMssg] = useState('');
    const [codeErrorMssg, setCodeErrorMssg] = useState('');
    const [serviceId, setServiceId] = useState('');
    const [phoneCountryCode, setPhoneCountryCode] = useState('');
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);


    useEffect(() => {
        axiosApiInstance.get(`/status`)
            .then(resp => setFilterKeywords(resp.data.data))
    }, [])


    useEffect(() => {
        axiosApiInstance.get(`/priority`)
            .then(resp => setFilterwords(resp.data.data))
    }, [])

    useEffect(() => {
        if (userPhoneNumber === '') {
            setTimeout(() => {
                setOpen(true);
            }, 2000);
        }
    }, []);

    useEffect(() => {
        if (code !== '') {
            setCodeErrorMssg('');
        }
    }, [code]);

    const selectedState = (id, state) => {
        setCalled(id);
        setIsActiveState(state);
        setStateVisible(true)
    }

    const removeState = () => {
        //props.setStat("");
        setIsActiveState(0)
        setStateVisible(false);
        setCalled(defaultStatus);
    }

    const removePriority = (id, state) => {
        setprio(0)
        setIsActivePriorty()
        setPriorityVisible(false)
    }


    const selectedPriorty = (id, state) => {
        setprio(state)
        setIsActivePriorty(state);
        setPriorityVisible(true)
    }

    const searchHandler = (searchTerm) => {
        setSearchTerm(searchTerm)
    }

    const handleClose = (e, reason) => {
        if (reason && reason == "backdropClick")
            return;
        setOpen(false);
    };

    const onSendCode = () => {
        const isValidPhoneNumber = phoneNumber ? phoneUtil.isValidNumberForRegion(phoneUtil.parse(phoneNumber, phoneCountryCode), phoneCountryCode) : '';

        if (phoneNumber === '') {
            setPhoneNumberErrorMssg('Phone number is required');
        } else if ( !isValidPhoneNumber ) {
            setPhoneNumberErrorMssg('Please enter valid phone number');
        } else {
            setPhoneNumberErrorMssg('');
            axiosApiInstance.get(`/user/getVerificationCode/${phoneNumber}`)
            .then(resp => {
                if (resp.data.succeeded) {
                    setServiceId(resp.data.data.serviceSid);
                    setOpen(false);
                    setTimeout(() => {
                        setIsVerifyPopupOpen(true);
                    }, 1000);
                }
            })
            .catch(error => console.log('error : ', error));
        }
    }

    const onVerifyCode = () => {
        let objectData = JSON.stringify({
            code: code.trim(),
            serviceSid: serviceId,
            phoneNumber: phoneNumber
        });
        if (code) {
            axiosApiInstance.post(`/user/verify`, objectData)
            .then(resp => {
                if (resp.data.succeeded) {
                    localStorage.setItem('userPhoneNumber', phoneNumber);
                    setIsVerifyPopupOpen(false);
                    setTimeout(() => {
                        setShowSuccessPopup(true);
                    }, 1000);
                }
            })
            .catch(error => console.log('error : ', error));
        } else {
            setCodeErrorMssg('Code is required');
        }
    }

    const handleVerifyPopupClose = (e, reason) => {
        if (reason && reason == "backdropClick")
            return;
        setIsVerifyPopupOpen(false);
    };

    const handleSuccessPopupClose = (e, reason) => {
        if (reason && reason == "backdropClick")
            return;
    };

    const phoneNumberPopup = () => {
        return (
            <Dialog open={open} onClose={handleClose} className='mytickets-popup-main-container'>
                <DialogContent>
                    <h3 className='mytickets-popup-title'>Phone Verifacation</h3>
                    <PhoneInput
                        country={'us'}
                        value={phoneNumber}
                        onChange={(phone, val) => {
                            setPhoneNumber(phone);
                            setPhoneCountryCode(val.countryCode);
                        }}
                    />
                    {phoneNumberErrorMssg &&
                        <div className='mytickets-popup-validation-error-container'><label className='mytickets-popup-validation-error'>{phoneNumberErrorMssg}</label></div>}
                    <div className='mytickets-popup-button-container'>
                        <Button onClick={onSendCode} className='mytickets-popup-button'>Send Code</Button>
                    </div>
                    <Close className='mytickets-popup-close-button' onClick={handleClose} />
                </DialogContent>
            </Dialog>
        );
    }

    const phoneVerificationPopup = () => {
        return (
            <Dialog open={isVerifyPopupOpen} onClose={handleVerifyPopupClose} className='mytickets-popup-main-container'>
                <DialogContent>
                    <div className='mytickets-popup-item-container-logo'>
                        <BtLogo className="mytickets-popup-bgtLogo" />
                    </div>
                    <label className='mytickets-popup-title-text'>Enter code</label>
                    <div className='mytickets-popup-icon-and-text-container'>
                        <MessageOutlined className='mytickets-popup-icon-style' />
                        <label>
                            we texted your phone {phoneNumber}. Please enter the code to sign in.
                        </label>
                    </div>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Code"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={code}
                        onChange={(event) => setCode(event.target.value)}
                    />
                    {codeErrorMssg &&
                        <div className='mytickets-popup-validation-error-container'><label className='mytickets-popup-validation-error'>{codeErrorMssg}</label></div>}
                    <div className='mytickets-popup-button-container'>
                        <Button onClick={onVerifyCode} className='mytickets-popup-button'>Verify</Button>
                    </div>
                    <Close className='mytickets-popup-close-button' onClick={handleVerifyPopupClose} />
                </DialogContent>
            </Dialog>
        );
    }

    const successPopup = () => {
        return (
            <Dialog open={showSuccessPopup} onClose={handleSuccessPopupClose}>
                <DialogContent>
                    <div className='mytickets-success-popup-text-container'>
                        <b className='mytickets-success-popup-text'>Your phone number has been successfully updated.</b>
                    </div>
                    <div className='mytickets-success-popup-button-container'>
                        <Button onClick={() => setShowSuccessPopup(false)} className='mytickets-popup-button'>ok</Button>
                    </div>
                    <Close className='mytickets-popup-close-button' onClick={() => setShowSuccessPopup(false)} />
                </DialogContent>
            </Dialog>
        );
    }

    return (
        <>
            <AllTicketsHeader searchKeyword={searchHandler} term={searchTerm}  />
            <SideBar />
            <div className="my-ticket-view">
                <div className="my-tickets-filter">
                    <div className="filter-bar">
                        <div className="filter-left">
                            <p>Status</p>
                            {
                                filterKeywords.map(stat => (
                                    <span key={stat.id} className={isActiveState === stat.name ? `activeness` : ""} onClick={() => selectedState(stat.id, stat.name)}>{stat.name}</span>

                                ))
                            }
                            {stateVisible ? <span onClick={removeState}>All Statuses</span> : ""}
                        </div>
                        <div className="filter-mid">
                            <p>Priority</p>
                            {
                                filterwords.map(text => (
                                    <span key={text.id} className={isActivePriorty === text.name ? `active ${text.name}` : ""} onClick={() => selectedPriorty(text.id, text.name)}>{text.name}
                                        <CircleIcon className={text.name === 'High' && "dot-icon-high"
                                            || text.name === 'Low' && "dot-icon-low"
                                            || text.name === 'Medium' && "dot-icon-med"} />
                                    </span>))}
                            {priorityVisible ? <span onClick={removePriority} className="all-prio">All Priorities</span> : " "}
                            <div style={{ display: "none" }}>
                                <span className="filter-span">Due Date<CalendarTodayIcon className="filter-icon" /></span>
                                <span className="filter-span">SLA<AlarmIcon className="filter-icon" /></span>
                            </div>
                        </div>
                        <div className="filter-right">
                            <CheckCircleIcon className="filter-icon-right" />
                            <CancelIcon className="filter-icon-right-2" />
                        </div>
                    </div>

                    {/* <FilterBar/> */}
                </div>
                <div className="my-tickets-display">
                    <MyTickets term={searchTerm} called={called} prio={prio} />
                </div>
            </div>
            {phoneNumberPopup()}
            {phoneVerificationPopup()}
            {successPopup()}
        </>
    )
}

export default MyTicketsView
